window.initializeQuoteWidgets = function($widgets) {
  var quoteSlideInterval = 8000;
  $widgets.each(function() {
    var $widget = $(this);
    var $images = $widget.find('.js-quote-image');
    var $quotes = $widget.find('.js-quote');

    if ( $images.length <= 0 ) {
      return; // nothing to do here
    }

    function showQuote($nextImage){
      var numberIn = $nextImage.data('index');
      $widget.data('index', numberIn);
      var $nextQuote = $quotes.filter('[data-index=' + numberIn + ']');
      var numberOut = $images.filter('.quotes__image--active').data('index');
      var $prevQuote = $quotes.filter(':visible');

      if (numberIn == numberOut) {
        return;
      }

      $images.removeClass('quotes__image--active');
      $nextImage.addClass('quotes__image--active');

      var directions = ["right", "left"];
      if ( numberIn > numberOut ) {
        directions = ["left", "right"];
      }
      $prevQuote.hide("slide", { direction: directions[0] }, 400, function(){
        // hide if previous animation didn't completely finish yet
        $quotes.hide();

        $nextQuote.show("slide", {
          direction: directions[1],
          easing: "easeOutExpo"
        }, 400);
      });
    }

    function carousel(){
      var stopped = $widget.data('stopped');
      if (stopped) {
        return;
      }
      var nextIndex = ($widget.data('index') || 0) + 1;
      if (nextIndex >= $images.length) {
        nextIndex = 0;
      }
      showQuote($images.filter('[data-index=' + nextIndex + ']'));
      setTimeout(carousel, quoteSlideInterval);
    }
    setTimeout(carousel, quoteSlideInterval);

    $images.click(function(event){
      var $image = $(this);
      $widget.data('stopped', true);
      showQuote($image);
    });
  });
}

$(document).ready(function() {
  var $quoteWidgets = $('.js-quotes');
  initializeQuoteWidgets($quoteWidgets);
});
